
import FolderConnection from "../../../assets/duotone/FolderConnection.svg";

import { IconProps } from "../../../types";

const cx = require('classnames');

export default function FolderConnectionIcon({ className, dataTestid = "FolderConnectionIcon", ...rest }: IconProps) {
  const classes = cx(className);

  return (
    <FolderConnection data-testid={dataTestid} className={classes} {...rest} />
  );
}
